import {createEffect, createStore} from 'effector'
import {fetchTransactions} from "../services/transactionsService";

export const refreshTransactions = createEffect(() => fetchTransactions());

export const transactionsStore = createStore([])
  .on(refreshTransactions.doneData, (_, transactions) => transactions)

// transactionsStore.watch((data) => console.log(data))